import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64c4ea5b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=64c4ea5b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4ea5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c4ea5b')) {
      api.createRecord('64c4ea5b', component.options)
    } else {
      api.reload('64c4ea5b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64c4ea5b&scoped=true", function () {
      api.rerender('64c4ea5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/cloudOrder/index.vue"
export default component.exports